import { __zcAsy, __zcFin, __zcIT, __zcITc, __zcMkv, __zcRd, __zcRf } from "__zod-compiler-runtime__";
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'

import {LinkSchema} from './link'
import {LinkGroupSchema} from './linkGroup'

export const SubnavSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('subnav', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      subNavHeading: safeOptional(LinkSchema),
      subNavSubHeading: safeOptional(LinkSchema),
      subNavLinks: safeOptional(z.array(LinkSchema.or(LinkGroupSchema))),
      subNavCta: safeOptional(LinkSchema),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["subNavHeading"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["subNavSubHeading"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["subNavLinks"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["subNavCta"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __rfz_0=__rf[0]._zod;
var __rfn_14=__rf[1];
var __rfn_17=__rf[2];
var __rfn_20=__rf[3];
var __rfn_23=__rf[4];
function safeParse_SubnavSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_1=_d["sys"];if(typeof __sv_1!=="object"||__sv_1===null||Array.isArray(__sv_1)){_e.push(__zcIT("object",__sv_1,["sys"]));}else{var __sv_3=__sv_1["id"];if(typeof __sv_3!=="string"){_e.push(__zcIT("string",__sv_3,["sys","id"]));}
var __sv_4=__sv_1["updatedAt"];if(__sv_4!==undefined){if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","updatedAt"]));}
}
var __sv_5=__sv_1["createdAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","createdAt"]));}
}
var __sv_6=__sv_1["contentType"];var __op_8="contentType" in __sv_1;var __ob_7=_e.length;var __rf_c0={async:false};var __rf_r0=__zcRd(__rfz_0,__sv_6,__rf_c0);if(__rf_r0.issues.length){__zcRf(__rf_r0.issues,__rf_c0,_e,["sys","contentType"]);}else{__sv_6=__rf_r0.value;}
if(!__op_8){__sv_6=undefined;if(_e.length===__ob_7){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_2={"id":__sv_3};if(__sv_4!==undefined||("updatedAt" in __sv_1)){__o_2["updatedAt"]=__sv_4;}if(__sv_5!==undefined||("createdAt" in __sv_1)){__o_2["createdAt"]=__sv_5;}if(__sv_6!==undefined||("contentType" in __sv_1)){__o_2["contentType"]=__sv_6;}__sv_1=__o_2;}
var __sv_9=_d["fields"];if(typeof __sv_9!=="object"||__sv_9===null||Array.isArray(__sv_9)){_e.push(__zcIT("object",__sv_9,["fields"]));}else{var __sv_11=__sv_9["title"];if(typeof __sv_11!=="string"){_e.push(__zcIT("string",__sv_11,["fields","title"]));}
var __sv_12=__sv_9["subNavHeading"];if(__sv_12!==undefined){var __ib_13=_e.length;if(_e.length===__ib_13){__sv_12=__rfn_14(__sv_12);if(__sv_12 instanceof Promise)__zcAsy();}
}
var __sv_15=__sv_9["subNavSubHeading"];if(__sv_15!==undefined){var __ib_16=_e.length;if(_e.length===__ib_16){__sv_15=__rfn_17(__sv_15);if(__sv_15 instanceof Promise)__zcAsy();}
}
var __sv_18=__sv_9["subNavLinks"];if(__sv_18!==undefined){var __ib_19=_e.length;if(_e.length===__ib_19){__sv_18=__rfn_20(__sv_18);if(__sv_18 instanceof Promise)__zcAsy();}
}
var __sv_21=__sv_9["subNavCta"];if(__sv_21!==undefined){var __ib_22=_e.length;if(_e.length===__ib_22){__sv_21=__rfn_23(__sv_21);if(__sv_21 instanceof Promise)__zcAsy();}
}
var __o_10={"title":__sv_11};if(__sv_12!==undefined||("subNavHeading" in __sv_9)){__o_10["subNavHeading"]=__sv_12;}if(__sv_15!==undefined||("subNavSubHeading" in __sv_9)){__o_10["subNavSubHeading"]=__sv_15;}if(__sv_18!==undefined||("subNavLinks" in __sv_9)){__o_10["subNavLinks"]=__sv_18;}if(__sv_21!==undefined||("subNavCta" in __sv_9)){__o_10["subNavCta"]=__sv_21;}__sv_9=__o_10;}
var __o_0={"sys":__sv_1,"fields":__sv_9};_d=__o_0;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_SubnavSchema,__zs,null,null);
})()

export type Subnav = z.infer<typeof SubnavSchema>
